<script>
import appConfig from '@src/app.config'
// import Loading from '@src/router/views/_loading2';
import {AxiosHelper} from '@src/utils/utils';
import jQuery from 'jquery'
import IFrameAudioPlayer from '@components/IFrameAudioPlayer'

// eslint-disable-next-line
new AxiosHelper();
window.$ = window.jQuery = jQuery;

export default {
	components: { IFrameAudioPlayer },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
	},
}
</script>

<template>
  <div id="app">
		<!-- <Loading/> -->
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
		<C.Toaster/>
		<IFrameAudioPlayer />

    <RouterView :key="$route.fullPath" />
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Design variables and utilities from src/design.
@import '@design';
</style>
